import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const TaskManagementSystem = () => {
  return <div><Comingsoonpage /></div>;
};

export default TaskManagementSystem;
